import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SeoTagsProps {
  title: string;
  description: string;
  image?: string;
  url: string;
  type?: 'website' | 'article' | 'product' | 'profile';
  noIndex?: boolean;
  structuredData?: object;
}

/**
 * Composant SEO universel pour gérer les balises meta et JSON-LD
 */
const SeoTags: React.FC<SeoTagsProps> = ({ 
  title, 
  description, 
  image = '/og-image.jpg', 
  url, 
  type = 'website',
  noIndex = false,
  structuredData
}) => {
  // Assurer que l'URL de l'image est absolue
  const fullImageUrl = image.startsWith('http') 
    ? image 
    : `${window.location.origin}${image.startsWith('/') ? '' : '/'}${image}`;

  return (
    <Helmet>
      {/* Balises standards */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      
      {/* Indexation */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="CashLive" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      
      {/* JSON-LD Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SeoTags;
